/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ValidationFaultPaymentUnknown } from "./ValidationFaultPaymentUnknown";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_UNKNOWN" = "PAYMENT_UNKNOWN"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to validation errors.
 */

// required attributes
const ValidationFaultPaymentUnknownProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: ValidationFaultPaymentUnknown
});

// optional attributes
const ValidationFaultPaymentUnknownProblemJsonO = t.partial({
  title: t.string
});

export const ValidationFaultPaymentUnknownProblemJson = t.intersection(
  [
    ValidationFaultPaymentUnknownProblemJsonR,
    ValidationFaultPaymentUnknownProblemJsonO
  ],
  "ValidationFaultPaymentUnknownProblemJson"
);

export type ValidationFaultPaymentUnknownProblemJson = t.TypeOf<
  typeof ValidationFaultPaymentUnknownProblemJson
>;
